/**
 * Returns the effective paymentProduct for a level in the hierarchy.
 *
 * Pass already-resolved paymentProduct objects from most specific to least specific.
 * Returns the first non-null value.
 *
 * Hierarchy: division → league → tournament (most specific first)
 *
 * @example
 * const effective = getEffectivePaymentProduct(
 *   resolvedDivisionProduct,  // most specific
 *   resolvedLeagueProduct,    // fallback
 *   resolvedTournamentProduct // last resort
 * );
 */
export function getEffectivePaymentProduct(...levels: (any | null | undefined)[]): any | null {
  return levels.find(p => p != null) ?? null;
}
